import {unblockUserFromOrganizationMutation as unblockUserFromOrganizationQueryId} from '@github-ui/server-persisted-queries'
import type {UnblockUserFromOrganizationMutationMutation} from '@github-ui/server-persisted-queries/types/unblockUserFromOrganizationMutation'
import {reactFetchJSON} from '@github-ui/verified-fetch'

type GraphQLResponse = {
  data?: UnblockUserFromOrganizationMutationMutation | null
  errors?: ReadonlyArray<{message?: string}> | null
}

const fallbackError = 'Failed to unblock user from organization'

export async function unblockUserFromOrganization({
  input,
  onError,
  onCompleted,
}: {
  input: {
    organizationId: string
    unblockedUserId: string
  }
  onError?: (error: Error) => void
  onCompleted?: () => void
}) {
  try {
    const [owner, repository, issueRouteType, issueNumber] = window.location.pathname.split('/').filter(Boolean)

    if (!owner || !repository || !issueNumber || (issueRouteType !== 'issues' && issueRouteType !== 'pull')) {
      throw new Error(fallbackError)
    }

    const query = new URLSearchParams({queryId: unblockUserFromOrganizationQueryId})
    const path = `/${encodeURIComponent(owner)}/${encodeURIComponent(repository)}/issues/${encodeURIComponent(issueNumber)}/organization_block?${query}`
    const response = await reactFetchJSON(path, {
      method: 'DELETE',
      body: {unblockedUserId: input.unblockedUserId},
    })

    if (!response.ok) {
      throw new Error(`${fallbackError} (${response.status})`)
    }

    const result = (await response.json()) as GraphQLResponse
    if (result.errors?.length || !result.data?.unblockUserFromOrganization) {
      throw new Error(result.errors?.[0]?.message ?? fallbackError)
    }

    onCompleted?.()
  } catch (error) {
    onError?.(error instanceof Error ? error : new Error(fallbackError))
  }
}
